import { render, staticRenderFns } from "./TeamArrivalDetails.vue?vue&type=template&id=4e985c05&"
import script from "./TeamArrivalDetails.vue?vue&type=script&lang=js&"
export * from "./TeamArrivalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports